import { authedFetch } from "./client";

/**
 * Account-level default model (founder 08-04) — the composer pill's server-side
 * home, so the default follows the user across devices and into server-minted
 * turns (routines, continuations, initiative). Mirrors the server contract in
 * `apps/server` (model-preference-routes): null = no preference, product
 * default governs.
 */
export interface ModelPreference {
  defaultModel: string | null;
  /** Fleet default from runtime_config (DB-managed, founder 2026-08-25).
   *  Optional so an older server keeps this client working. */
  productDefault?: string;
}

/** Read the user's account default model. */
export async function getModelPreference(): Promise<ModelPreference> {
  const res = await authedFetch("/api/preferences/model");
  return (await res.json()) as ModelPreference;
}

/** Persist (or clear, with null) the user's account default model. 204, no body. */
export async function updateModelPreference(
  defaultModel: string | null
): Promise<void> {
  await authedFetch("/api/preferences/model", {
    method: "PUT",
    body: JSON.stringify({ defaultModel }),
  });
}
